import { Alert } from "react-bootstrap";
import { useLocation } from "react-router";

import ChangeEmailForm from "../components/ChangeEmailForm";
import ChangePasswordForm from "../components/ChangePasswordForm";
import TabHeader from "../components/TabHeader";

const MyAccountManage = () => {
	const { state } = useLocation();

	return (
		<>
			<TabHeader title="Account Preferences" />
			{state?.message ? <Alert variant={state.variant || "success"}>{state.message}</Alert> : null}
			<ChangeEmailForm />
			<hr className="mb-5" />
			<ChangePasswordForm />
		</>
	);
};

export default MyAccountManage;
